export const SALES_CHANNEL_COLORS = {
  ecommerce: '#D000F7',
  direct: '#3BC0FF',
  free: '#1DC79E',
} as const;
